import React from 'react';
import ITSupport from "../../../images/IT Support.png";
import Modal from "../../Common/Modals/Modal";
import StyledImageFluid from "../Image.styled";
import {Color} from "../../Common/Colors";
import Button from "../../Common/Buttons/Button";

const ITSupportModalButton = () => {

    const [isOpen, setIsOpen] = React.useState(false);

    const showModal = () => {
        setIsOpen(true);
    };

    const hideModal = () => {
        setIsOpen(false);
    };

    return (
        <div>
            <Button type="button" className="btn btn-primary" onClick={showModal}>Read more...</Button>
            <Modal id="customerServiceModal"
                   title="Customer Service &amp; Incident Tracking"
                   onClose={hideModal}
                   show={isOpen}>
                <StyledImageFluid src={ITSupport} alt="IT Support" backgroundColor={Color.warning} rounded/>
                <p><strong>Customer Service</strong> experience troubleshooting and resolving end user system and
                    application issues.</p>
                <ul>
                    <li> Used a variety of 3rd party Information Technology Service Management(ITSM) software solutions
                        to track and resolve issues. Communicated and collaborate with teammates, end users, and data
                        center operations during the resolution process.
                    </li>
                    <li>Troubleshot and resolved hardware, software, and networking issues running on various Linux and
                        Windows server platforms and Windows Desktop operating systems.
                    </li>
                    <li>Supported software applications built on the LAMP stack (Linux, Apache, MySql, PHP, Perl) and
                        the Java platform (Java, Groovy, Spring, Hibernate, XML, Json, REST API).
                    </li>
                    <li>Served as a technical liason creating wiki support documentation used to aid managers, end
                        users, paratechs, system engineers, and developers in the ability to more quickly resolve
                        complex system processes.
                    </li>
                    <li>Used Windows PE and Clonezilla to create bootable USB drives and computer images used for
                        setting up and configuring desktop\laptop computers.
                    </li>
                </ul>
            </Modal>
        </div>
    );
}

export default ITSupportModalButton;